export const SUB_FIELDS_FOR_CHECKING = {
  recyclableTypes: {
    parentField: 'recyclable',
  },
  secondaryLanguage: {
    parentField: 'bilingual',
  },
};
